export default __webpack_public_path__ + "static/media/diagramIcon_3.b52bbae6.svg";